import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, Globe, Instagram, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import Logo from '../common/Logo';
import { CONTACT_INFO, MENU_ITEMS } from '../../utils/constants';
import { fadeInUp, staggerContainer, staggerItem } from '../../utils/animations';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark text-primary-beige">
      <div className="container mx-auto px-4 py-16">
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >

          {/* Quick Links */}
          <motion.div variants={staggerItem}>
            <h3 className="text-xl font-serif text-white mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-primary-tan hover:text-white transition-colors text-sm"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-primary-tan hover:text-white transition-colors text-sm"
                >
                  About Us
                </Link>
              </li>
              {MENU_ITEMS.map((item) => (
                <li key={item.id}>
                  <Link
                    to={item.path}
                    className="text-primary-tan hover:text-white transition-colors text-sm"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Services */}
          <motion.div variants={staggerItem}>
            <h3 className="text-xl font-serif text-white mb-6">Our Services</h3>
            <ul className="space-y-3 text-sm text-primary-tan">
              <li>Paint & Coatings</li>
              <li>Construction Finishing</li>
              <li>Texture & Designer Finishes</li>
              <li>Waterproofing Solutions</li>
              <li>Interior & Exterior Coatings</li>
              <li>Consultation & Support</li>
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div variants={staggerItem}>
            <h3 className="text-xl font-serif text-white mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Phone size={18} className="text-primary-brown mt-1 flex-shrink-0" />
                <a
                  href={`tel:${CONTACT_INFO.phone}`}
                  className="text-primary-tan hover:text-white transition-colors text-sm"
                >
                  {CONTACT_INFO.phone}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail size={18} className="text-primary-brown mt-1 flex-shrink-0" />
                <a
                  href={`mailto:${CONTACT_INFO.email}`}
                  className="text-primary-tan hover:text-white transition-colors text-sm"
                >
                  {CONTACT_INFO.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Globe size={18} className="text-primary-brown mt-1 flex-shrink-0" />
                <a
                  href={`https://${CONTACT_INFO.website}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-tan hover:text-white transition-colors text-sm"
                >
                  {CONTACT_INFO.website}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Instagram size={18} className="text-primary-brown mt-1 flex-shrink-0" />
                <a
                  href={`https://instagram.com/${CONTACT_INFO.instagram.replace('@', '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-tan hover:text-white transition-colors text-sm"
                >
                  {CONTACT_INFO.instagram}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-primary-brown mt-1 flex-shrink-0" />
                <span className="text-primary-tan text-sm">
                  {CONTACT_INFO.address}
                </span>
              </li>
            </ul>
          </motion.div>
        </motion.div>

        {/* Bottom Bar */}
        <motion.div
          className="border-t border-primary-brown border-opacity-30 mt-12 pt-8"
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-primary-tan text-sm">
              © {currentYear} CraftCoat Solutions. All rights reserved.
            </p>
            
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;